(function(){
  'use strict';
  function init(root){
    var scroller = root.querySelector('[data-rfy-scroller]');
    if(!scroller) return;
    var list = scroller.querySelector('.rfy__list');
    var prev = root.querySelector('.rfy__arrow--prev');
    var next = root.querySelector('.rfy__arrow--next');
    var dotsWrap = root.querySelector('[data-rfy-dots]');

    function getStep(){
      var firstItem = list && list.querySelector('.rfy__item');
      if(!firstItem) return 280;
      var style = window.getComputedStyle(firstItem);
      var width = firstItem.getBoundingClientRect().width;
      var marginRight = parseFloat(style.marginRight || '0');
      var marginLeft = parseFloat(style.marginLeft || '0');
      return Math.ceil(width + marginLeft + marginRight);
    }

    function getPageIndex(){
      if(!list) return 0;
      var step = getStep();
      return Math.round(scroller.scrollLeft / step);
    }

    function getPageCount(){
      if(!list) return 0;
      var step = getStep();
      var visible = Math.max(1, Math.floor(scroller.clientWidth / step));
      var total = list.children.length;
      var pages = Math.max(1, Math.ceil(total / visible));
      return pages;
    }

    function renderDots(){
      if(!dotsWrap) return;
      var pages = getPageCount();
      dotsWrap.innerHTML = '';
      if(pages <= 1){ dotsWrap.style.display = 'none'; return; } else { dotsWrap.style.display = ''; }
      for(var i=0;i<pages;i++){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'rfy__dot';
        dot.setAttribute('role','tab');
        dot.setAttribute('aria-selected', i===0 ? 'true' : 'false');
        dot.setAttribute('aria-label','Ir para página ' + (i+1));
        dot.dataset.index = String(i);
        dotsWrap.appendChild(dot);
      }
      dotsWrap.querySelectorAll('.rfy__dot').forEach(function(dot){
        dot.addEventListener('click', function(){
          var step = getStep();
          var idx = parseInt(dot.getAttribute('data-index')) || 0;
          scroller.scrollTo({left: step * idx, behavior: 'smooth'});
        });
      });
      updateDots();
    }

    function updateDots(){
      if(!dotsWrap) return;
      var idx = getPageIndex();
      dotsWrap.querySelectorAll('.rfy__dot').forEach(function(dot, i){
        var active = i === idx;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateArrows(){
      if(!list) return;
      var maxScroll = list.scrollWidth - scroller.clientWidth;
      var x = scroller.scrollLeft;
      if(prev) prev.disabled = x <= 0;
      if(next) next.disabled = x >= maxScroll - 2;
      updateDots();
    }

    // Button navigation
    if(prev){ prev.addEventListener('click', function(){ scroller.scrollBy({left: -getStep(), behavior: 'smooth'}); }); }
    if(next){ next.addEventListener('click', function(){ scroller.scrollBy({left: getStep(), behavior: 'smooth'}); }); }

    // Drag to scroll (mouse/touch)
    var isDown = false;
    var startX = 0;
    var startLeft = 0;

    function onPointerDown(e){
      isDown = true;
      scroller.classList.add('is-dragging');
      startX = (e.touches ? e.touches[0].pageX : e.pageX);
      startLeft = scroller.scrollLeft;
    }
    function onPointerMove(e){
      if(!isDown) return;
      var x = (e.touches ? e.touches[0].pageX : e.pageX);
      var dx = x - startX;
      scroller.scrollLeft = startLeft - dx;
      e.preventDefault();
    }
    function onPointerUp(){
      isDown = false;
      scroller.classList.remove('is-dragging');
    }

    scroller.addEventListener('mousedown', onPointerDown);
    scroller.addEventListener('mousemove', onPointerMove);
    document.addEventListener('mouseup', onPointerUp);

    scroller.addEventListener('touchstart', onPointerDown, {passive:true});
    scroller.addEventListener('touchmove', onPointerMove, {passive:false});
    scroller.addEventListener('touchend', onPointerUp);

    // Wheel horizontal scroll support
    scroller.addEventListener('wheel', function(e){
      if(Math.abs(e.deltaY) > Math.abs(e.deltaX)){
        scroller.scrollBy({left: e.deltaY, behavior: 'auto'});
        e.preventDefault();
      }
    }, {passive:false});

    // Keyboard navigation when focused
    scroller.tabIndex = 0;
    scroller.addEventListener('keydown', function(e){
      if(e.key === 'ArrowRight'){
        scroller.scrollBy({left: getStep(), behavior: 'smooth'});
      } else if(e.key === 'ArrowLeft'){
        scroller.scrollBy({left: -getStep(), behavior: 'smooth'});
      }
    });

    scroller.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);
    renderDots();
    updateArrows();
  }
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.rfy').forEach(init);
  });
})();
